<script>
let href = window.location.href;
</script>
<style>
  .loginbox {
    padding: 0em 0.5em 0em 0.5em;
  }
  .loginbox input {
    margin: 1em 0em 1em 0em;
    display: block;
  }
  .logininput {
    width: 100%;
  }
  h3 {
    margin-top: 0.2em;
    margin-bottom: 0em;
  }
  p.note {
    color: #888;
  }
</style>

  <div class="loginbox" >
     <h3>Log In</h3>
     <p class="note">Logging in is required to use Dropbox if you don't have an account you can <a href="https://castingwords.com/customer/login?just_create=1">create an account here</a> </p>
    <form action="/store/customer/login" method="POST" name="login_form">
    <input type="hidden" name="final" value="{href}" novalidate="true"/>
    <input type="email" name="email" class="logininput" placeholder="Email" novalidate="true"  autocomplete="email"  />
    <input novalidate="true" placeholder="Password" type="password" name="password" class="logininput"  autocomplete="current-password"/>
    <input class="btn btn-default orange" value="Log In" name="form_submit" type="submit" novalidate="true"/>
    </form>
  </div>
